import firebase from 'firebase'

var firebaseApp = firebase.initializeApp({
    apiKey: 
    "AIzaSyC_ivLsRIJMG-gKiRrXFbil0PbFGDs7lEA",
    authDomain: "she-foundation-c934b.firebaseapp.com",
    databaseURL: "https://she-foundation-c934b.firebaseio.com",
    projectId: "she-foundation-c934b",
    storageBucket: "she-foundation-c934b.appspot.com",
    messagingSenderId: "379658262769",
    appId: "1:379658262769:web:91487e27097a3f1cf4f150",
    measurementId: "G-5BVK2WFK8G"
  });
  
  var db = firebaseApp.firestore();

  export { db };
  